import { render, staticRenderFns } from "./PensionCost.vue?vue&type=template&id=6d74c1a1&"
import script from "./PensionCost.vue?vue&type=script&lang=js&"
export * from "./PensionCost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports